import { Script } from '../interfaces/file-to-load.interface';

export const ScriptStore: Script[] = [
  { name: 'chatLoggedOut', src: '//uae.fw-cdn.com/40156381/94720.js', chat: true, widgetId: 'ff7c4527-6a84-4bbc-a60f-c9c3712173be' },
  { name: 'chatLoggedIn', src: '//uae.fw-cdn.com/40156381/94720.js', chat: true, widgetId: '7f558198-d60e-4599-8a6a-f6dc22173970' },
];
